<template>
    <div class="about__section">
        <h3>Misc</h3>
        <dl>
            <dt>UI</dt>
            <dd>
                <button class="btn btn-default btn-sm"
                        @click="showUiTest()">
                    Show UI Test
                </button>
            </dd>
        </dl>
        <dl>
            <dt>Errors</dt>
            <dd>
                <button class="btn btn-default btn-sm"
                        @click="throwError()">
                    Throw Error
                </button>
            </dd>
        </dl>
    </div>
</template>

<script>
export default {
    name: 'DebugMiscSection',

    emits: [
        'close',
    ],

    methods: {
        showUiTest() {
            window.location.hash = '/ui-test';
            // This closes the Debug Modal and the About Modal otherwise they sit on top of the UI page.
            this.$emit('close');
        },

        throwError() {
            throw new Error('This is a test error');
        },
    },
};
</script>
